<template>
  <wrap-container>
    <select-options
      label="Motivo"
      title="¿Cuál es el motivo de la solicitud?"
    />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SelectOptions from "@/components/SelectOptions";

export default {
  name: "CuentaPaquete",
  components: {
    WrapContainer,
    SelectOptions
  }
};
</script>

<style scoped></style>
